import { moneyFormatterWithoutCurrency } from "@/utils/moneyFormat";
import numberFormatter from "@/utils/numberFormatter";

import { PriceWithGeedeeDetails, PriceWithoutGeedeeDetails } from "./types";

export const hasValue = (value?: number | string | null) =>
  value !== null && value !== undefined && value !== "";

export const formatCurrency = (value?: number | null) => {
  if (!hasValue(value)) return "";

  return moneyFormatterWithoutCurrency(Number(value));
};

export const formatKwh = (value?: number | null) => {
  if (!hasValue(value)) return "";

  return numberFormatter(Number(value));
};

export const formatTariff = (value?: number | null) => {
  if (!hasValue(value)) return "";

  return Number(value).toLocaleString("pt-BR", {
    minimumFractionDigits: 5,
    maximumFractionDigits: 5,
  });
};

export const hasPriceWithoutGeedeeDetails = (details?: PriceWithoutGeedeeDetails | null) => {
  const consumption = details?.consumption_details;
  const expenses = details?.other_expenses;
  const accountTotal = details?.account_total;

  return Boolean(
    hasValue(consumption?.energy_consumed_kwh) ||
    hasValue(consumption?.energy_tariff_brl_per_kwh) ||
    hasValue(consumption?.total_consumption_brl) ||
    expenses?.items?.some((item) => hasValue(item?.amount_brl)) ||
    hasValue(expenses?.total_other_expenses_brl) ||
    hasValue(accountTotal?.total_amount_brl),
  );
};

export const hasPriceWithGeedeeDetails = (details?: PriceWithGeedeeDetails | null) => {
  const brpDetails = details?.brp_solar_generation_details;
  const lightDetails = details?.light_consumption_and_other_expenses;
  const lightConsumption = lightDetails?.consumption;
  const lightExpenses = lightDetails?.other_expenses;
  const accountTotal = details?.account_total;

  return Boolean(
    hasValue(brpDetails?.gdi?.energy_consumed_kwh) ||
    hasValue(brpDetails?.gdi?.energy_tariff_brl_per_kwh) ||
    hasValue(brpDetails?.gdii?.energy_consumed_kwh) ||
    hasValue(brpDetails?.gdii?.energy_tariff_brl_per_kwh) ||
    hasValue(brpDetails?.total_payable_brp_brl) ||
    hasValue(lightConsumption?.energy_consumed_kwh) ||
    hasValue(lightConsumption?.energy_tariff_brl_per_kwh) ||
    hasValue(lightConsumption?.total_consumption_brl) ||
    hasValue(lightExpenses?.non_compensable_items_brl) ||
    lightExpenses?.items?.some((item) => hasValue(item?.amount_brl)) ||
    hasValue(lightExpenses?.total_other_expenses_brl) ||
    hasValue(lightDetails?.total_payable_light_brl) ||
    hasValue(accountTotal?.total_amount_brl),
  );
};
